import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import { drawerWidth } from 'kosmosConfig';
import Link from '@mui/material/Link';

const Root = styled('div')(({ theme }) => ({
  fontSize: 14,
  marginTop: theme.spacing(3),
  marginLeft: theme.spacing(3),
  marginBottom: theme.spacing(6),
  color: 'white',
  zIndex: 1000,
  width: drawerWidth,
}));

export default function Footer(): JSX.Element {
  const { t } = useTranslation('default');

  return (
    <Root>
      <div>
        &#169; {new Date().getFullYear()}{' '}
        <Link color="inherit" href="https://www.coriolisesg.com/" target="_blank" underline="hover">
          TradeSun, Inc.
        </Link>
      </div>
      <br />
      <div>
        <Link
          color="inherit"
          href="https://pnqa35.p3cdn1.secureserver.net/wp-content/uploads/2023/01/Coriolis-Privacy-Policy.pdf"
          target="_blank"
          underline="hover"
        >
          {t('terms-privacy')}
        </Link>
      </div>
    </Root>
  );
}
